// Every deploy replaces the page files and gives them new names, so a tab
// opened before a deploy fails the next time it loads a page it has not
// visited yet. Reloading picks up the deployed version.
const STALE_PAGE_FILE_MESSAGES = [
  'Failed to fetch dynamically imported module', // Chrome, Edge
  'error loading dynamically imported module', // Firefox
  'Importing a module script failed', // Safari
  'Unable to preload CSS', // Vite, a page's stylesheet
];

const RELOAD_STORAGE_KEY = 'hs-stale-page-files-reloaded-at';
const RELOAD_WINDOW_MS = 30_000;

export function isStalePageFileError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return STALE_PAGE_FILE_MESSAGES.some((text) => message.includes(text));
}

/**
 * Reloads the page once to pick up the deployed files. Returns false without
 * reloading when this tab already reloaded in the last 30 seconds (the files
 * are missing for another reason) or the browser blocks session storage, so
 * the caller shows an error instead of reloading in a loop.
 */
export function reloadForNewDeploy(
  reload: () => void = () => window.location.reload(),
  now: number = Date.now()
): boolean {
  try {
    const reloadedAt = Number(window.sessionStorage.getItem(RELOAD_STORAGE_KEY));
    if (reloadedAt && now - reloadedAt < RELOAD_WINDOW_MS) return false;
    window.sessionStorage.setItem(RELOAD_STORAGE_KEY, String(now));
  } catch {
    return false;
  }
  reload();
  return true;
}
